import r from "moment";
function u(i, n, l, m = 6e5, s) {
  const c = i.valueOf(), d = n.valueOf() - m, o = [];
  for (let e = c; e <= d; e += m) {
    const t = s ? r(e).locale(s) : r(e), a = t.valueOf();
    l.some((f) => f.timestamp === a) || o.push({
      timestamp: a,
      timeLabel: t.format("HH:mm"),
      dayLabel: t.format("dddd")
    });
  }
  return o;
}
export {
  u as default
};
